import { createApiClient } from '@kolab/dms-base/api'

const DOORPIN_API_BASE = import.meta.env.VITE_API_BASE_URL || '/api'

const client = createApiClient(DOORPIN_API_BASE)
export default client
